import * as tslib_1 from "tslib";
import { OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators, } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { GalavailServiceEcommer } from "clientwsGalavail";
import { NgWebflowService } from "ngweflow";
import { CabinaItinerarioMenorWrapper } from "src/app/classes/cabina-itinerario-menor-wrapper";
import { PassengerType } from "src/app/enums/passenger-type.enum";
import { CabinService } from "src/app/services/cabin/cabin.service";
import { PromoService } from "src/app/services/promo.service";
import { StoreInquireService } from "src/app/services/store-inquire.service";
import { UtilsService } from "src/app/services/utils.service";
import { environment } from "src/environments/environment";
import { isNullOrUndefined } from "util";
import { RoyalRequestService } from "../form/royal-request.service";
import { OnholdService } from "./onhold.service";
import { WebFlowAction } from "src/app/core/enums/web-flow-actions.enum";
import { SearchCountryField, CountryISO, TooltipLabel } from 'ngx-intl-tel-input-angular7';
var OnholdComponent = /** @class */ (function () {
    function OnholdComponent(fb, cabinService, ngWebflowService, galavailServiceEcommer, onholdService, activatedRoute, storeLocalInquireService, router, royalRequestService, promoService) {
        this.fb = fb;
        this.cabinService = cabinService;
        this.ngWebflowService = ngWebflowService;
        this.galavailServiceEcommer = galavailServiceEcommer;
        this.onholdService = onholdService;
        this.activatedRoute = activatedRoute;
        this.storeLocalInquireService = storeLocalInquireService;
        this.router = router;
        this.royalRequestService = royalRequestService;
        this.promoService = promoService;
        this.adults = 1;
        this.children = 0;
        this.URLMonth = '';
        this.URLYear = '';
        this.URLDateRange = '';
        this.hasEmailRequest = false;
        this.codeValidationEntered = "";
        this.token = "";
        this.messageCode = "";
        this.codeError = "";
        this.isLoading = false;
        this.isLoadingOnHold = false;
        this.initialized = false;
        this.monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        this.geoIp = "";
        this.urlElementsArray = [];
        this.disableChildren = false;
        this.webFlowAction = WebFlowAction;
        this.SearchCountryField = SearchCountryField;
        this.TooltipLabel = TooltipLabel;
        this.CountryISO = CountryISO;
        this.cabinasItinerarioMenorWrapper = [];
        this.isVisibleDialog = false;
        this.getDataofUrl();
        this.disableChildren = this.keyCompany != 'MTg2' ? false : true;
    }
    OnholdComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.royalRequestService.getGeoIpDirection().subscribe(function (ip) {
            _this.geoIp = ip;
        });
        this.selectedCabins = 1;
        this.numberOfPassengers = this.cruise.minimumGroupOnly;
        this.adults = this.cruise.availability[this.cruise.iterIndex].groupsOnly
            ? this.numberOfPassengers
            : 1;
        this.cabinForms = this.createCabinForms();
        this.createForm();
        this.getCabinInformation();
        this.ngWebflowService.addWebFlowAction(this.webFlowAction.INIT_ON_HOLD, {
            cruise: this.cruise,
        });
        this.manageURLMonthYear();
    };
    OnholdComponent.prototype.manageURLMonthYear = function () {
        var startDate = new Date(Date.parse(this.galavailServiceEcommer.getDataofLocalStorage('dataInquire-' + this.keyCompany).startDate));
        var endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, startDate.getDate());
        var companyDateRange = this.dataCompany.fechasBusquedaDefault;
        this.URLDateRange = companyDateRange.length != 0 ? companyDateRange :
            this.galavailServiceEcommer.getDataofLocalStorage('daterange') ? this.galavailServiceEcommer.getDataofLocalStorage('daterange') :
                this.formatDate(startDate) + '-' + this.formatDate(endDate);
    };
    ;
    OnholdComponent.prototype.getDataofUrl = function () {
        var _this = this;
        this.subscription = this.activatedRoute.params.subscribe(function (params) {
            _this.empresa = params["company"];
            _this.keyCompany = params["code"];
            _this.codeAvailability = params["codeAvailability"];
            _this.storeLocalInquireService.getLocalStorages(_this.keyCompany);
        });
    };
    Object.defineProperty(OnholdComponent.prototype, "remarksValue", {
        get: function () {
            return this.formGroupOnHold.get("remarks").value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OnholdComponent.prototype, "referenceValue", {
        get: function () {
            return this.formGroupOnHold.get("reference").value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OnholdComponent.prototype, "emailValue", {
        get: function () {
            return this.formGroupOnHold.get("email").value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OnholdComponent.prototype, "telephoneValue", {
        get: function () {
            return this.formGroupOnHold.get("telephone").value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OnholdComponent.prototype, "itiObjectValue", {
        get: function () {
            return this.formGroupOnHold.get("itiObject").value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OnholdComponent.prototype, "agencyValue", {
        get: function () {
            return this.formGroupOnHold.get("agency").value;
        },
        enumerable: true,
        configurable: true
    });
    OnholdComponent.prototype.addCabin = function () {
        this.selectedCabins = +1;
    };
    OnholdComponent.prototype.createForm = function () {
        this.formGroupOnHold = this.fb.group({
            email: ["", [Validators.required, Validators.email]],
            reference: ["", [Validators.required]],
            remarks: [""],
            telephone: [""],
            agency: [""],
            itiObject: [null]
        });
    };
    OnholdComponent.prototype.getFilteredCabinaItinerarioMenorWrapper = function (currentCabinFormIndex) {
        var _this = this;
        try {
            var filteredCabinaItinerarioMenorWrapper_1 = [];
            this.cabinasItinerarioMenorWrapper.forEach(function (cabinaItinerarioMenorWrapper, indexCabinasItinerarioMenor) {
                var isSelectedInSomeForm = false;
                _this.getCabinFormsArray().controls.forEach(function (cabinFormGroup, index) {
                    if (!isNullOrUndefined(cabinFormGroup.get("cabinaItinerarioMenor").value)) {
                        if (currentCabinFormIndex !== index &&
                            Number(cabinFormGroup.get("cabinaItinerarioMenor").value) ===
                                indexCabinasItinerarioMenor) {
                            isSelectedInSomeForm = true;
                        }
                    }
                });
                filteredCabinaItinerarioMenorWrapper_1.push({
                    cabina: cabinaItinerarioMenorWrapper,
                    selected: isSelectedInSomeForm,
                });
            });
            return filteredCabinaItinerarioMenorWrapper_1;
        }
        catch (error) {
            console.error(error);
            return [];
        }
    };
    OnholdComponent.prototype.validateAllFormFields = function (formGroup) {
        var _this = this;
        console.log(formGroup);
        Object.keys(formGroup.controls).forEach(function (field) {
            var control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            }
            else if (control instanceof FormGroup) {
                _this.validateAllFormFields(control);
            }
        });
    };
    OnholdComponent.prototype.save = function () {
        var _this = this;
        var request = {
            email: this.emailValue,
            timeMaximumCode: this.dataCompany.timeMaximumCode,
            maximumOnHold: this.dataCompany.maximumOnHold,
            company: this.dataCompany.code
        };
        try {
            this.isLoading = true;
            this.ngWebflowService.addWebFlowAction(this.webFlowAction.ON_HOLD_REQUEST_CODE_START, { request: request }, true);
            this.galavailServiceEcommer
                .getCodeVerification(request)
                .subscribe(function (resp) {
                _this.hasEmailRequest = true;
                _this.token = resp.token;
                _this.messageCode = resp.message;
                _this.codeError = resp.code;
                _this.isLoading = false;
                _this.ngWebflowService.addWebFlowAction(_this.webFlowAction.ON_HOLD_REQUEST_CODE_SUCCESS, { request: request }, true);
            });
        }
        catch (error) {
            this.isLoading = false;
            this.ngWebflowService.addWebFlowAction(this.webFlowAction.ON_HOLD_REQUEST_CODE_ERROR, { error: error, request: request }, true);
            console.error(error);
        }
    };
    OnholdComponent.prototype.setRemainingAdults = function () { };
    OnholdComponent.prototype.getPrice = function (cabinFormIndex) {
        try {
            var currentCabinaItinerarioMenorWrapper = this.getCurrentCabinaItinerarioMenorWrapper(cabinFormIndex);
            if (isNullOrUndefined(currentCabinaItinerarioMenorWrapper)) {
                return null;
            }
            var isIncludeCabinSupplement = this.isIncludeSupplementInCabin(cabinFormIndex);
            return currentCabinaItinerarioMenorWrapper.getAppPrice(this.cruise.category, false, isIncludeCabinSupplement, PassengerType.ADULT, this.cabinService);
        }
        catch (error) {
            console.log("SelectCabinFormComponent.getPrice()");
            console.error(error);
            return null;
        }
    };
    OnholdComponent.prototype.getWasPrice = function (cabinFormIndex) {
        try {
            var currentCabinaItinerarioMenorWrapper = this.getCurrentCabinaItinerarioMenorWrapper(cabinFormIndex);
            if (isNullOrUndefined(currentCabinaItinerarioMenorWrapper)) {
                return null;
            }
            var isIncludeSupplement = this.isIncludeSupplementInCabin(cabinFormIndex);
            return currentCabinaItinerarioMenorWrapper.getWasPrice(this.cruise.category, false, isIncludeSupplement, PassengerType.ADULT, this.cabinService);
        }
        catch (error) {
            console.error("SelectCabinFormComponent.getPrice() > An error has happened: " + error);
            return null;
        }
    };
    OnholdComponent.prototype.isIncludeSupplementInCabin = function (cabinFormIndex) {
        try {
            var totalAdultsInCabin = this.getTotalNumerOfSelectedPassengersByCabinByType(cabinFormIndex, PassengerType.ADULT);
            var totalPassengersInCabin = this.getTotalNumberOfSelectedPassengersByCabin(cabinFormIndex);
            return totalAdultsInCabin === 1 && totalPassengersInCabin === 1;
        }
        catch (error) {
            console.log("SelectCabinFormComponent.isIncludeSupplementInCabin()");
            console.error(error);
        }
    };
    OnholdComponent.prototype.getTotalNumerOfSelectedPassengersByCabinByType = function (indexCabinForm, passengerType) {
        try {
            var cabinFormGroup = this.getCabinFormsArrayElement(indexCabinForm);
            if (isNullOrUndefined(cabinFormGroup)) {
                throw new Error();
            }
            return this.getTotalNumerOfSelectedPassengersByCabinFormByType(cabinFormGroup, passengerType);
        }
        catch (error) {
            console.error(error);
            throw error;
        }
    };
    OnholdComponent.prototype.getTotalNumberOfSelectedPassengersByCabin = function (cabinFormIndex) {
        var numberOfSelectedPassengers = 0;
        try {
            var cabinFormGroup = this.getCabinFormsArrayElement(cabinFormIndex);
            if (isNullOrUndefined(cabinFormGroup)) {
                return 0;
            }
            numberOfSelectedPassengers =
                this.getTotalNumerOfSelectedPassengersByCabinForm(cabinFormGroup);
            return numberOfSelectedPassengers;
        }
        catch (error) {
            console.log("SelectCabinFormComponent.getTotalNumberOfSelectedPassengersByCabin()");
            console.error(error);
            throw error;
        }
    };
    OnholdComponent.prototype.getBedTypeName = function (index) {
        try {
            var cabinaItinerarioMenorWrapper = this.getCurrentCabinaItinerarioMenorWrapper(index);
            if (isNullOrUndefined(cabinaItinerarioMenorWrapper)) {
                return null;
            }
            var camaCabinaListSelected = this.getCabinFormsFormControlValue(index, "camaCabinaList");
            if (isNullOrUndefined(camaCabinaListSelected)) {
                return null;
            }
            var camaCabiaList = cabinaItinerarioMenorWrapper.getCamaCabinaList();
            if (isNullOrUndefined(camaCabiaList) ||
                camaCabiaList.length === 0 ||
                isNullOrUndefined(camaCabiaList[camaCabinaListSelected])) {
                return null;
            }
            return camaCabiaList[camaCabinaListSelected.valueOf()].description;
        }
        catch (error) {
            console.log("SelectCabinFormComponent.getBedTypeName(): " + error);
            console.error(error);
            return null;
        }
    };
    OnholdComponent.prototype.getListOfBeds = function (indexCabinForm) {
        try {
            var cabinaItinerarioMenorValue = this.getCabinFormsFormControlValue(indexCabinForm, "cabinaItinerarioMenor");
            if (isNullOrUndefined(cabinaItinerarioMenorValue)) {
                return [];
            }
            var itinerarioWrapper = this.cabinasItinerarioMenorWrapper[cabinaItinerarioMenorValue];
            if (isNullOrUndefined(itinerarioWrapper)) {
                return [];
            }
            return itinerarioWrapper.getCamaCabinaList();
        }
        catch (error) {
            console.error("SelectCabinComponent.getListOfBeds() > An error has happened " + error);
            return [];
        }
    };
    OnholdComponent.prototype.getCurrentCabinaItinerarioMenorWrapper = function (cabinFormIndex) {
        try {
            var cabinaItinerarioMenorSelected = this.getCabinFormsFormControlValue(cabinFormIndex, "cabinaItinerarioMenor");
            if (isNullOrUndefined(cabinaItinerarioMenorSelected)) {
                return null;
            }
            return this.cabinasItinerarioMenorWrapper[cabinaItinerarioMenorSelected];
        }
        catch (error) {
            console.error("SelectCabinFormComponent.getCurrentCabinaItinerarioMenorWrapper() > An error has happened: " +
                error);
            return null;
        }
    };
    OnholdComponent.prototype.getCabinFormsFormControlValue = function (index, controlName) {
        try {
            var cabinFormsFormControl = this.getCabinFormsFormControl(index, controlName);
            return isNullOrUndefined(cabinFormsFormControl)
                ? null
                : cabinFormsFormControl.value;
        }
        catch (error) {
            console.error(error);
            return null;
        }
    };
    OnholdComponent.prototype.getCabinFormsFormControl = function (index, controlName) {
        try {
            var cabinFormsArrayElement = this.getCabinFormsArrayElement(index);
            return isNullOrUndefined(cabinFormsArrayElement)
                ? null
                : cabinFormsArrayElement.get(controlName);
        }
        catch (error) {
            console.error(error);
            return null;
        }
    };
    OnholdComponent.prototype.getCabinInformation = function () {
        var _this = this;
        var itinerary = this.cruise.availability[this.selectedItinerary];
        if (!itinerary) {
            return null;
        }
        try {
            var requestCabin = {
                adults: this.adults,
                children: 0,
                itinerary: itinerary.code,
                code: this.dataCompany.code,
            };
            this.galavailServiceEcommer.findCabins(requestCabin).subscribe(function (cabinasItinerarioMenor) {
                cabinasItinerarioMenor.forEach(function (cabinaItinerarioMenor) {
                    cabinaItinerarioMenor.packageCode = _this.packageCode;
                    cabinaItinerarioMenor.percents =
                        _this.cruise.availability[_this.selectedItinerary].percents;
                    var cabinaItinerarioMenorWrapper = new CabinaItinerarioMenorWrapper(cabinaItinerarioMenor);
                    _this.cabinasItinerarioMenorWrapper.push(cabinaItinerarioMenorWrapper);
                });
                _this.initialized = true;
            }, function (error) {
                console.error("SelectCabinFormComponent.getCabinInformation() -> An error happened while de app was trying to" +
                    "get the cabin information ");
                console.error(error);
                _this.cabinasItinerarioMenorWrapper = [];
            });
        }
        catch (error) {
            console.error("Error happened in SelectCabinFormComponent.getCabinInformation() > " +
                error);
        }
    };
    OnholdComponent.prototype.getCabinForms = function () {
        var formGroups = [];
        if (this.cabinForms !== undefined &&
            this.cabinForms !== null &&
            this.cabinForms.contains("cabinForms")) {
            formGroups = this.cabinForms.get("cabinForms")
                .controls;
            var currentNumberOfCabinForms = this.cabinForms.get("cabinForms").length;
            var differenceBetweenCurrentAndNewForm = this.selectedCabins;
            if (differenceBetweenCurrentAndNewForm > 0) {
                for (var i = 0; i < differenceBetweenCurrentAndNewForm; i++) {
                    formGroups.push(this.createCabinForm());
                }
            }
            else if (differenceBetweenCurrentAndNewForm < 0) {
                for (var i = 0; i < differenceBetweenCurrentAndNewForm * -1; i++) {
                    formGroups.pop();
                }
            }
        }
        else {
            for (var i = 0; i < this.selectedCabins; i++) {
                formGroups.push(this.createCabinForm());
            }
        }
        return new FormArray(formGroups);
    };
    OnholdComponent.prototype.addCabinForm = function () {
        if (this.cabinsFormArray.length > this.dataCompany.maximumCabinOnHold - 1) {
            this.dialogObj = {
                title: "Info",
                message: "If you require more than " + this.dataCompany.maximumCabinOnHold + " cabins , please contact your Account Manager directly or e-mail " + this.dataCompany.infoEmail,
            };
            this.isVisibleDialog = true;
            this.ngWebflowService.addWebFlowAction(this.webFlowAction.TRY_ADD_CABIN_ON_HOLD, {
                message: this.dialogObj.message,
            });
            return 0;
        }
        if (this.cabinasItinerarioMenorWrapper.length > this.cabinsFormArray.length) {
            if (this.cabinForms !== undefined &&
                this.cabinForms !== null &&
                this.cabinForms.contains("cabinForms")) {
                this.cabinsFormArray.push(this.createCabinForm());
                this.ngWebflowService.addWebFlowAction(this.webFlowAction.TRY_ADD_CABIN_ON_HOLD, {
                    message: "Added successfully",
                });
            }
        }
        else {
            this.dialogObj = {
                title: "Info",
                message: "There is not more cabins",
            };
            this.ngWebflowService.addWebFlowAction(this.webFlowAction.TRY_ADD_CABIN_ON_HOLD, {
                message: this.dialogObj.message,
            });
            this.isVisibleDialog = true;
        }
    };
    Object.defineProperty(OnholdComponent.prototype, "cabinsFormArray", {
        get: function () {
            return this.cabinForms.get("cabinForms");
        },
        enumerable: true,
        configurable: true
    });
    OnholdComponent.prototype.getArrayControls = function () {
        var cabinsformgroup = this.cabinForms.controls["cabinForms"];
        var formGroups = cabinsformgroup.controls;
        return formGroups;
    };
    OnholdComponent.prototype.cabinFormChanged = function () { };
    OnholdComponent.prototype.deleteCabinForm = function (index) {
        var cabinsformgroup = this.cabinForms.controls["cabinForms"];
        var formGroups = cabinsformgroup.controls;
        if (this.cabinForms !== undefined &&
            this.cabinForms !== null &&
            this.cabinForms.contains("cabinForms")) {
            var control = this.cabinForms.get("cabinForms");
            this.ngWebflowService.addWebFlowAction(this.webFlowAction.ON_HOLD_DELETE_CABIN, { message: "success" }, true);
            control.removeAt(index);
        }
    };
    OnholdComponent.prototype.createCabinForm = function () {
        return new FormGroup({
            cabinaItinerarioMenor: new FormControl(-1, [
                Validators.required,
                Validators.min(0),
            ]),
            camaCabinaList: new FormControl(-1),
            adults: new FormControl(this.storeLocalInquireService.getPaseengers()
                ? this.storeLocalInquireService.getPaseengers()
                : 1, Validators.required),
            children: new FormControl(-1, [Validators.required, Validators.min(0)]),
        }, this.validateCabinForm.bind(this));
    };
    OnholdComponent.prototype.validateCabinForm = function (cabinFormGroup) {
        try {
            var resultError = {};
            var validateCabinForm = { validationError: true };
            var cabinaItinerarioMenorValue = cabinFormGroup.get("cabinaItinerarioMenor").value;
            if (isNullOrUndefined(cabinaItinerarioMenorValue)) {
                return validateCabinForm;
            }
            var cabinaItinerarioMenorWrapper = this.cabinasItinerarioMenorWrapper[cabinaItinerarioMenorValue];
            if (isNullOrUndefined(cabinaItinerarioMenorWrapper)) {
                return validateCabinForm;
            }
            var selectedPassengers = this.getTotalNumerOfSelectedPassengersByCabinForm(cabinFormGroup);
            if (selectedPassengers > cabinaItinerarioMenorWrapper.getCapacidad()) {
                resultError["exceededCapacity"] = {
                    capacity: cabinaItinerarioMenorWrapper.getCapacidad(),
                    selectedPassengers: selectedPassengers,
                };
            }
            if (this.isChildWithOutAdultByCabinForm(cabinFormGroup)) {
                resultError["childrenWithoutAdult"] = true;
            }
            return resultError;
        }
        catch (error) {
            console.error(error);
            return { validationError: true };
        }
    };
    OnholdComponent.prototype.getTotalNumerOfSelectedPassengersByCabinForm = function (cabinFormGroup) {
        var numberOfSelectedPassengers = 0;
        try {
            if (isNullOrUndefined(cabinFormGroup)) {
                return 0;
            }
            if (cabinFormGroup.contains("cabinaItinerarioMenor") &&
                !isNullOrUndefined(cabinFormGroup.get("cabinaItinerarioMenor").value)) {
                if (cabinFormGroup.contains("adults") &&
                    !isNullOrUndefined(cabinFormGroup.contains("adults")) &&
                    cabinFormGroup.contains("children") &&
                    !isNullOrUndefined(cabinFormGroup.contains("children"))) {
                    numberOfSelectedPassengers +=
                        Number(cabinFormGroup.get("adults").value) +
                            Number(cabinFormGroup.get("children").value);
                }
            }
            return numberOfSelectedPassengers;
        }
        catch (error) {
            console.error(error);
            throw error;
        }
    };
    OnholdComponent.prototype.getCabinTypeName = function (index) {
        try {
            var cabinaItinerarioMenorWrapper = this.getCurrentCabinaItinerarioMenorWrapper(index);
            if (isNullOrUndefined(cabinaItinerarioMenorWrapper)) {
                return null;
            }
            return cabinaItinerarioMenorWrapper.getCabinaFullName();
        }
        catch (error) {
            console.error("SelectCabinFormComponent.getCabinTypeName() > An error has happened while executing the method. " +
                error);
            return null;
        }
    };
    OnholdComponent.prototype.isChildWithOutAdultByCabinForm = function (cabinFormGroup) {
        try {
            var totalNumerOfSelectedAdults = this.getTotalNumerOfSelectedPassengersByCabinFormByType(cabinFormGroup, PassengerType.ADULT);
            var totalNumerOfSelectedChildren = this.getTotalNumerOfSelectedPassengersByCabinFormByType(cabinFormGroup, PassengerType.CHILD);
            return (totalNumerOfSelectedAdults === 0 && totalNumerOfSelectedChildren > 0);
        }
        catch (error) {
            console.error(error);
            throw error;
        }
    };
    OnholdComponent.prototype.getTotalNumerOfSelectedPassengersByCabinFormByType = function (cabinFormGroup, passengerType) {
        var numberOfSelectedPassengers = 0;
        try {
            if (isNullOrUndefined(cabinFormGroup)) {
                return 0;
            }
            if (cabinFormGroup.contains("cabinaItinerarioMenor") &&
                !isNullOrUndefined(cabinFormGroup.get("cabinaItinerarioMenor").value)) {
                if (passengerType === PassengerType.ADULT) {
                    if (cabinFormGroup.contains("adults") &&
                        !isNullOrUndefined(cabinFormGroup.contains("adults"))) {
                        numberOfSelectedPassengers += Number(cabinFormGroup.get("adults").value);
                    }
                }
                else if (passengerType === PassengerType.CHILD) {
                    if (cabinFormGroup.contains("children") &&
                        !isNullOrUndefined(cabinFormGroup.contains("children"))) {
                        numberOfSelectedPassengers += Number(cabinFormGroup.get("children").value);
                    }
                }
                else {
                    throw new Error();
                }
            }
            return numberOfSelectedPassengers;
        }
        catch (error) {
            console.error(error);
            throw error;
        }
    };
    OnholdComponent.prototype.validateCabinForms = function (cabinFormsGroup) {
        var _this = this;
        var resultError = {};
        var totalPassengers = 0;
        var totalAdults = 0;
        var totalChildren = 0;
        var cabinaItinerarioMenorValues = [];
        try {
            var cabinFormArray = cabinFormsGroup.get("cabinForms");
            if (isNullOrUndefined(cabinFormArray)) {
                return { validationError: true };
            }
            cabinFormArray.controls.forEach(function (cabinForm) {
                totalAdults += _this.getTotalNumerOfSelectedPassengersByCabinFormByType(cabinForm, PassengerType.ADULT);
                totalChildren +=
                    _this.getTotalNumerOfSelectedPassengersByCabinFormByType(cabinForm, PassengerType.CHILD);
                var cabinaItinerarioMenorValue = cabinForm.get("cabinaItinerarioMenor").value;
                for (var i = 0; i < cabinaItinerarioMenorValues.length; i++) {
                    if (!isNullOrUndefined(cabinaItinerarioMenorValue) &&
                        cabinaItinerarioMenorValues[i] === cabinaItinerarioMenorValue) {
                        if (isNullOrUndefined(resultError["repeatedCabin"])) {
                            resultError["repeatedCabin"] = [
                                Number(cabinaItinerarioMenorValues[i]),
                            ];
                        }
                        else {
                            var resultErrorRepeatedCabinValue = resultError["repeatedCabin"];
                            resultErrorRepeatedCabinValue.push(Number(cabinaItinerarioMenorValues[i]));
                            resultError["repeatedCabin"] = resultErrorRepeatedCabinValue;
                        }
                        break;
                    }
                }
                if (!isNullOrUndefined(cabinaItinerarioMenorValue)) {
                    cabinaItinerarioMenorValues.push(cabinaItinerarioMenorValue);
                }
            });
            totalPassengers = totalAdults + totalChildren;
            if (this.cruise.availability[this.cruise.iterIndex].groupsOnly) {
                if (totalPassengers > this.numberOfPassengers) {
                    resultError["exceededPassengers"] = false;
                }
                if (totalPassengers < this.numberOfPassengers) {
                    resultError["remainingPassengers"] = false;
                }
            }
            if (totalAdults > this.adults) {
                //resultError['exceededAdults'] = false;
            }
            if (totalChildren > this.children) {
                //resultError['exceededChildren'] = false;
            }
            if (totalAdults < this.adults) {
                // resultError['remainingAdults'] = false;
            }
            if (totalChildren < this.children) {
                // resultError['remainingChildren'] = false;
            }
            return resultError;
        }
        catch (error) {
            console.error(error);
            return { validationError: true };
        }
    };
    OnholdComponent.prototype.createCabinForms = function () {
        this.cabinForms = new FormGroup({ cabinForms: this.getCabinForms() }, this.validateCabinForms.bind(this));
        return this.cabinForms;
    };
    OnholdComponent.prototype.getNumberOfChildrenAsArray = function (index) {
        try {
            var numberOfElements = this.getNumberOfPassengersForCabin(index, PassengerType.CHILD);
            return numberOfElements > 0
                ? UtilsService.getArrayOfNumbersByRange(0, numberOfElements)
                : [0];
        }
        catch (error) {
            console.error("SelectCabinFormComponent.getNumberOfAdultsArray > An error has happened: " +
                error);
            return [];
        }
    };
    OnholdComponent.prototype.getNumberOfPassengersForCabin = function (cabinFormIndex, passengerTpe) {
        try {
            var cabinFormGroup = this.getCabinFormsArrayElement(cabinFormIndex);
            return this.getNumberOfPassengersForCabinByFormGroup(cabinFormGroup, passengerTpe);
        }
        catch (error) {
            console.error("SelectCabinFormComponent.getNumberOfPassengersForCabin() -> An error has happened" +
                error);
            throw error;
        }
    };
    OnholdComponent.prototype.isValidRowsCabin = function () {
        try {
            return this.cabinsFormArray.status === "VALID" ? true : false;
        }
        catch (error) {
            console.error("SelectCabinFormComponent.getNumberOfPassengersForCabin() -> An error has happened" +
                error);
            throw error;
        }
    };
    OnholdComponent.prototype.getCabinFormsArrayElement = function (index) {
        try {
            var cabinFormArray = this.getCabinFormsArray();
            return isNullOrUndefined(cabinFormArray)
                ? null
                : cabinFormArray.get(index.toString());
        }
        catch (error) {
            console.error(error);
            return null;
        }
    };
    OnholdComponent.prototype.getCabinFormsArray = function () {
        try {
            return isNullOrUndefined(this.cabinForms)
                ? null
                : this.cabinForms.get("cabinForms");
        }
        catch (error) {
            console.error(error);
            return null;
        }
    };
    OnholdComponent.prototype.getNumberOfPassengersForCabinByFormGroup = function (cabinFormGroup, passengerType) {
        try {
            var cabinaItinerarioMenorSelectedValue = cabinFormGroup.get("cabinaItinerarioMenor").value;
            if (isNullOrUndefined(cabinaItinerarioMenorSelectedValue)) {
                return 0;
            }
            var cabinaItinerarioMenorWrapper = this.cabinasItinerarioMenorWrapper[cabinaItinerarioMenorSelectedValue];
            if (isNullOrUndefined(cabinaItinerarioMenorWrapper)) {
                return 0;
            }
            if (passengerType === PassengerType.ADULT) {
                return cabinaItinerarioMenorWrapper.getCapacidadAdultos();
            }
            else if (passengerType === PassengerType.CHILD) {
                return cabinaItinerarioMenorWrapper.getCapacidadNinos();
            }
            else {
                return 0;
            }
        }
        catch (error) {
            console.log("SelectCabinFormComponent.getNumberOfPassengersForCabinByFormGroup()");
            console.error(error);
            return 0;
        }
    };
    OnholdComponent.prototype.getMainColor = function () {
        return "#" + this.dataCompany.mainColor;
    };
    OnholdComponent.prototype.getSecundaryColor = function () {
        return "#" + this.dataCompany.secondaryColor;
    };
    OnholdComponent.prototype.getNumberOfAdultsAsArray = function (index) {
        try {
            var numberOfElements = this.getNumberOfPassengersForCabin(index, PassengerType.ADULT);
            return numberOfElements > 0
                ? UtilsService.getArrayOfNumbersByRange(1, numberOfElements)
                : [];
        }
        catch (error) {
            console.error("SelectCabinFormComponent.getNumberOfAdultsArray > An error has happened: " +
                error);
            return [];
        }
    };
    OnholdComponent.prototype.addLog = function (title) {
        this.ngWebflowService.addWebFlowAction(title, { formGroupOnHold: tslib_1.__assign({}, this.formGroupOnHold.value) }, true);
    };
    OnholdComponent.prototype.addLogCabins = function (title) {
        this.ngWebflowService.addWebFlowAction(title, { cabinForms: tslib_1.__assign({}, this.cabinsFormArray.value) }, true);
    };
    OnholdComponent.prototype.getValid = function (controlName) {
        return (this.formGroupOnHold.get(controlName).invalid &&
            this.formGroupOnHold.get(controlName).touched);
    };
    OnholdComponent.prototype.setCodeEntered = function (event) {
        console.log(event);
        this.ngWebflowService.addWebFlowAction(this.webFlowAction.ON_HOLD_ENTERED_CODE, { message: event }, true);
        this.codeValidationEntered = event;
    };
    OnholdComponent.prototype.blockCabin = function () {
        var _this = this;
        try {
            this.isLoadingOnHold = true;
            var valueRequest_1 = this.createRequest();
            this.ngWebflowService.addWebFlowAction(this.webFlowAction.ON_HOLD_REQUEST_START, valueRequest_1);
            this.onholdService.onHold(valueRequest_1).subscribe(function (resp) {
                console.log(resp);
                if (resp.status) {
                    _this.dialogObj = {
                        title: "Ok",
                        message: resp.message,
                    };
                    _this.ngWebflowService.addWebFlowAction(_this.webFlowAction.ON_HOLD_REQUEST_SUCCESS, { message: "success" });
                    // here request CRM
                    if (_this.empresa === "royal") {
                        _this.requestRoyalForm();
                    }
                    else {
                        _this.redirectThanksPage();
                    }
                }
                else {
                    _this.dialogObj = {
                        title: "Error",
                        message: resp.message,
                    };
                    _this.ngWebflowService.addWebFlowAction(_this.webFlowAction.ON_HOLD_REQUEST_FAILED, { message: "Failed", request: valueRequest_1 });
                    _this.isVisibleDialog = true;
                }
                _this.isLoadingOnHold = false;
            }, function (error) {
                _this.isLoadingOnHold = false;
                console.log(error);
                _this.ngWebflowService.addWebFlowAction(_this.webFlowAction.ON_HOLD_REQUEST_ERROR, { message: "Error", request: valueRequest_1, error: error });
            });
        }
        catch (error) {
            console.error(error);
            this.isLoadingOnHold = false;
        }
    };
    OnholdComponent.prototype.requestRoyalForm = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                url = this.getUrlRequest();
                console.log("url::::", url);
                this.ngWebflowService.addWebFlowAction(this.webFlowAction.CRM_ON_HOLD_START, url);
                this.royalRequestService.requestGetForRoyal(url).subscribe(function (x) {
                    console.log("Observer got a next value: " + x);
                    _this.ngWebflowService.addWebFlowAction(_this.webFlowAction.CRM_ON_HOLD_SUCCESS, tslib_1.__assign({}, x));
                }, function (err) {
                    _this.ngWebflowService.addWebFlowAction(_this.webFlowAction.CRM_ON_HOLD_FAILED, {
                        url: url,
                        err: err,
                    });
                    _this.redirectThanksPage();
                }, function () {
                    _this.redirectThanksPage();
                });
                return [2 /*return*/];
            });
        });
    };
    OnholdComponent.prototype.getUrlRequest = function () {
        var cruiseIndex = this.cruise.iterIndex;
        var startDate = new Date(this.cruise.availability[cruiseIndex].startDate);
        var endDate = new Date(this.cruise.availability[cruiseIndex].endDate);
        var promoText = this.getPromoName(cruiseIndex) === "0"
            ? "Regular Rate"
            : this.getPromoName(cruiseIndex);
        var newLetter = "0";
        this.urlElementsArray = [];
        var urlFinal = environment.pathCRMroyal;
        this.getStringFormDatailRoyal(promoText);
        this.getStringTravelDataRoyal(startDate, endDate);
        this.getInterestDataRoyal();
        this.getContactInfoRoyal();
        this.getStringUtm();
        this.urlElementsArray.push(newLetter);
        this.urlElementsArray.push(this.geoIp);
        this.setLastFourItmes();
        var urlEscapedElementsArray = this.urlElementsArray.map(function (urlElement) {
            return encodeURIComponent(urlElement);
        });
        urlFinal += urlEscapedElementsArray.join("/");
        return urlFinal;
    };
    OnholdComponent.prototype.setLastFourItmes = function () {
        this.urlElementsArray.push(this.isMobile());
        this.urlElementsArray.push("Not specific");
        this.urlElementsArray.push("Not specific");
        this.urlElementsArray.push(this.getCodeProcessByCruise());
    };
    OnholdComponent.prototype.isMobile = function () {
        var ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
            return "Tablet";
        }
        else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
            return "Mobile";
        }
        else {
            return "Desktop";
        }
    };
    OnholdComponent.prototype.getCodeProcessByCruise = function () {
        return "RG." + this.cruise.initials + ".HOLD";
    };
    OnholdComponent.prototype.getStringUtm = function () {
        var utms = this.royalRequestService.getUtm();
        this.urlElementsArray.push(utms.utm_source);
        this.urlElementsArray.push(utms.utm_medium);
        this.urlElementsArray.push(utms.utm_campaign);
        this.urlElementsArray.push(utms.utm_term);
        this.urlElementsArray.push(utms.utm_adgroup);
        this.urlElementsArray.push(utms.utm_matchtype);
        this.urlElementsArray.push(utms.utm_content);
        return utms.utm_source + "/" + utms.utm_medium + "/" + utms.utm_campaign + "/" + utms.utm_term + "/" + utms.utm_adgroup + "/" + utms.utm_matchtype + "/" + utms.utm_content + "/";
    };
    OnholdComponent.prototype.getContactInfoRoyal = function () {
        var fName = this.referenceValue;
        var lName = "none";
        var email = this.emailValue;
        var phone = isNullOrUndefined(this.telephoneValue) || this.telephoneValue === ""
            ? "Not specific"
            : this.telephoneValue;
        var country = "none";
        var agency = this.agencyValue === "" ? "Not specific" : this.agencyValue;
        var reference = "Not specific";
        this.urlElementsArray.push(fName);
        this.urlElementsArray.push(lName);
        this.urlElementsArray.push(email);
        this.urlElementsArray.push(phone);
        this.urlElementsArray.push(country);
        this.urlElementsArray.push(agency);
        this.urlElementsArray.push(reference);
        return fName + "/" + lName + "/" + email + "/" + phone + "/" + country + "/" + agency + "/" + reference + "/";
    };
    OnholdComponent.prototype.getPromoName = function (itineraryIndex) {
        try {
            return (this.promoService.getPromoText(this.cruise.availability[itineraryIndex].promotionType, this.cruise.availability[itineraryIndex].promotionValue) || "");
        }
        catch (error) {
            console.log("ResultsComponent.getPromoName()");
            console.error(error);
            return null;
        }
    };
    OnholdComponent.prototype.getInterestDataRoyal = function () {
        var interestString = "";
        this.urlElementsArray.push("0");
        this.urlElementsArray.push("0");
        this.urlElementsArray.push("0");
        this.urlElementsArray.push("0");
        interestString = "0/0/0/0/";
        return interestString;
    };
    OnholdComponent.prototype.getStringTravelDataRoyal = function (startDate, endDate) {
        var _this = this;
        var totalAdults = 0;
        var totalChildren = 0;
        var cabinFormArray = this.cabinForms.get("cabinForms");
        cabinFormArray.controls.forEach(function (cabinForm) {
            totalAdults += _this.getTotalNumerOfSelectedPassengersByCabinFormByType(cabinForm, PassengerType.ADULT);
            totalChildren += _this.getTotalNumerOfSelectedPassengersByCabinFormByType(cabinForm, PassengerType.CHILD);
        });
        var arrivalDate = "";
        var departureDate = "";
        var daysCruise = this.storeLocalInquireService.getLength().substring(0, 1);
        var optionCruise = this.storeLocalInquireService
            .getNameIti()
            .substring(this.storeLocalInquireService.getNameIti().length, 1);
        var numberAdults = totalAdults;
        var numberChild = totalChildren;
        var comments = this.remarksValue === "" ? "None specific" : this.remarksValue;
        var dayString = startDate.getDate() < 10
            ? "0" + String(startDate.getDate())
            : String(startDate.getDate());
        var endDayString = endDate.getDate() < 10
            ? "0" + String(endDate.getDate())
            : String(endDate.getDate());
        arrivalDate = this.monthNames[startDate.getMonth()] + " " + dayString + ", " + startDate.getFullYear();
        departureDate = this.monthNames[endDate.getMonth()] + " " + endDayString + ", " + endDate.getFullYear();
        this.urlElementsArray.push(arrivalDate);
        this.urlElementsArray.push(departureDate);
        this.urlElementsArray.push(daysCruise);
        this.urlElementsArray.push(optionCruise.trim());
        this.urlElementsArray.push(String(numberAdults));
        this.urlElementsArray.push(String(numberChild));
        this.urlElementsArray.push(comments + "- FROM ON HOLD ONLINE");
        this.urlElementsArray.push("en");
        return arrivalDate + "/" + departureDate + "/" + daysCruise + "/" + optionCruise + "/" + numberAdults + "/" + numberChild + "/" + comments + "/en/";
    };
    OnholdComponent.prototype.getStringFormDatailRoyal = function (promoText) {
        var product = this.royalRequestService.getNameBoatToRoyal(this.storeLocalInquireService.getBoat());
        var resp = "none" + "/" + product + "/" + promoText + "/";
        this.urlElementsArray.push("none");
        this.urlElementsArray.push(product);
        this.urlElementsArray.push(promoText);
    };
    OnholdComponent.prototype.createRequest = function () {
        var _this = this;
        var cabins = [];
        this.cabinForms.value.cabinForms.forEach(function (element) {
            var index = Number(element.cabinaItinerarioMenor);
            if (index >= 0) {
                var departure = _this.cabinasItinerarioMenorWrapper[index].getCode();
                var cabin = {
                    departure: departure,
                    adults: element.adults,
                    children: element.children,
                    acomodation: element.camaCabinaList,
                };
                cabins.push(cabin);
            }
        });
        var emails = [];
        emails.push(this.dataCompany.emailEcommerce);
        return {
            token: this.token,
            validatorCode: Number(this.codeValidationEntered),
            email: this.emailValue,
            emails: emails,
            type: 1,
            reference: "" + this.referenceValue,
            itinerary: this.cruise.availability[0].code,
            boat: this.cruise.code.toString(),
            cabins: cabins,
            remarks: "Remarks: " +
                this.remarksValue +
                " Email: " +
                this.emailValue +
                " Telephone: " +
                (this.itiObjectValue.dialCode + this.itiObjectValue.number) +
                " Agency: " +
                this.agencyValue,
            aditionalServices: this.cruise.availability[0].aditionalServices,
            itiObject: this.itiObjectValue
        };
    };
    OnholdComponent.prototype.redirectThanksPage = function () {
        // console.log('REDIRECCIONA A LA PAGINA DE GRACIAS');
        // this.router.navigate(['/inquire/' + this.empresa + '/' + this.keyCompany + '/thanks']);
        this.router.navigate([
            this.empresa + "/" + this.keyCompany + "/thanks-onhold",
            { boat: this.storeLocalInquireService.getBoat(), contact: "inquire" },
        ]);
    };
    OnholdComponent.prototype.setBedType = function (i) {
        try {
            var formAux = this.cabinsFormArray.at(i);
            formAux.get("camaCabinaList").patchValue(this.getListOfBeds(i)[0].code);
            formAux.get("children").patchValue(0);
        }
        catch (error) {
            console.log(error);
        }
    };
    OnholdComponent.prototype.goBack = function () {
        this.router.navigate([
            this.empresa + "/All/All/" + this.URLDateRange + "/1",
        ]);
    };
    OnholdComponent.prototype.formatDate = function (date) {
        var dayString = date.getDate() < 10 ? '0' : '';
        var monthString = date.getMonth() < 9 ? '0' : '';
        var dateString = dayString + date.getDate().toString() + monthString + (date.getMonth() + 1).toString() + date.getFullYear().toString();
        return dateString;
    };
    return OnholdComponent;
}());
export { OnholdComponent };
